<template>
  <div>
    <b-modal
          hide-footer
          size="md"
          no-close-on-backdrop
          no-close-on-esc
          centered
          ref="images"
          id="images"
          title="ADICIONAR IMAGEM"
          class ="centralizatexto"
        >
        <template #modal-title>
          <div class="header-title">ADICIONAR IMAGEM</div>
        </template>
        <div class="scroll">
          <div>
            <div class="flex">
              <p class="label-visit mb-2 mt-2"> Imagem da Planta </p>
            </div>
            <div class="vistoria">
              <div class="col-md-12 planta_container" >
                <div class="flex">
                  <div v-if="isPdf == false" class="img-planta" @click="openfilevistoria">
                      <div class="icone-pdf">
                          <div class="d-flex justify-content-center">
                              <i class="fas fa-cloud-upload-alt icon-upload text-center"></i>
                          </div>
                          <button class="import-ar-button">Anexe a Planta</button>
                      </div>
                  </div>
                  <div v-else-if="isPdf == true" class="pdf-vistoria">
                      <div class="file-delete-vistoria"  @click="RemovePlanta"><i class="fas fa-times-circle"></i></div>
                      <div class="pdf-vistoria-download" @click="downloadFileVistoria(dataFiles)"><i class="fas fa-download"></i></div>
                      <div v-if="dataFiles.extensao == 'jpeg' || dataFiles.extensao == 'png' || dataFiles.extensao == 'jpg'">
                        <img class="pdfVistoria" @click="imageDetails"  :src="'data:image/jpeg;base64,' + dataFiles.arquivo"/>
                      </div>
                      <div v-else>
                        <i  @click="imageDetails" class="fas fa-file icone-file pdfVistoria"></i>
                      </div>

                      <div class="pdfVistoria-footer"><div class="text-overflow">{{dataFiles.descricao == null ? 'N/D' : dataFiles.descricao}}</div></div>
                  </div>
                </div>
                 <input accept="image/png, image/jpeg,application/pdf, application/vnd.ms-excel" class="input-invisible"  @change="SendFileVistoriaTecnica"  type="file" id="img-planta" />
              </div>
            </div>
        </div>
        </div>
        <div class="container-buttons-form mt-3 pt-3">
           <button @click="cancelImage" class="button-cancel">Fechar</button>
            <button @click="SendFileVistoriaTecnica" v-if="dataFiles == ''" class="button-save">Salvar</button>
        </div>
    </b-modal>

        <b-modal ref="modalPdfImagemSelector" hide-footer hide-header id="modal-center" centered title="BootstrapVue">
          <div v-show="isPdf">
             <div v-if="dataFiles.extensao == 'jpeg' || dataFiles.extensao == 'png' || dataFiles.extensao == 'jpg'">
                <img class="imgGrande" :src="'data:image/jpeg;base64,' + dataFiles.arquivo"/>
             </div>
             <div v-else>
                  <iframe
                    style="overflow: hidden"
                    id="pdfViewer"
                    scrolling="no"
                    class="mb-2 pdf-overview"
                    :src="'data:application/pdf;base64,'+ dataFiles.arquivo + '#toolbar=0&navpanes=0&scrollbar=0'" frameborder="0">
                  </iframe>
             </div>
          </div>
        </b-modal>
  </div>

</template>

<script>
import imageselector from './imageselector.js'
export default imageselector
</script>

<style scoped>
.flex{
  display: flex;
  justify-content: center;
}
.vistoria{
  display: flex;
  justify-content: center;
}
.imgGrande{
  height: 100%;
  width: 100%;
}
.icone-file {
  font-size: 5rem;
  padding: 4rem;
}

.text-overflow{
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    display: flex;
    justify-content: center;
    font-family:'Segoe UI';
    font-size: 14px;
    align-items: center;
}
.pdf-vistoria{
    height: 11rem;
    width: 80%;
    display: flex;
    justify-content: center;
    position: relative;
    background: #F6F6F6;
    align-items: center;
    border: 1px dashed gray;
    border-radius: 10px;
    cursor: pointer;
}
.pdfVistoria{
    height: 100%;
    width: 100%;
    border-radius: 10px;
    margin-bottom: 15px;
}
.pdfVistoria-footer{
    height: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    font-weight: bold;
    color: rgb(31, 31, 31);
    border-radius: 0px 0px 10px 10px;
    position: absolute;
    bottom: 0px;
    background: rgba(180, 180, 180);
    width: 100%;
}
.pdf-vistoria-download{
    height: 30px;
    width: 30px;
    position: absolute;
    top: 0px;
    left: 0px;
    display: flex;
    border-radius: 10px 0px 10px 0px;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    color: white;
    font-weight: bold;
    background: #008148;

}
.file-delete-vistoria{
    height: 30px;
    width: 30px;
    position: absolute;
    top: 0px;
    right: 0px;
    display: flex;
    border-radius: 0px 10px 0px 10px;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    color: white;
    font-weight: bold;
    background: red;
}
.input-invisible{
    visibility: hidden;
}
.import-ar-button{
 border: none;
 height: 40px;
 background: white;
 border-radius: 10px;
 font-size: 14px;
 padding: 10px;
 /* font-weight: bold; */
 color: #666666;
 background-color: #F6F6F6;
}
.icon-upload {
    font-size: 2.5rem;
}

.icone-pdf{
    font-size: 25px;
    display: flex;
    flex-direction: column;
    gap: 1.rem;
}
.img-planta{
    height: 200px;
    width: 80%;
    display: flex;
    justify-content: center;
    position: relative;
    background: #F6F6F6;
    align-items: center;
    border: 1px dashed gray;
    border-radius: 10px;
    cursor: pointer;
}
.planta_container{
    width: 60%;
    padding: 0;
}
.label-visit{
    font: normal normal normal 16px/21px Segoe UI;
    font-size: 15px;
    color: #666666;
    margin-bottom: 0px;
    font-weight: bold;
}

.scroll{
    height: 30vh;
    overflow: auto;
    border-bottom: 1px solid #D4D4D4;
    border-radius: 10px;
}
.scroll::-webkit-scrollbar-track {
    background-color: #F4F4F4;
    border-radius: 10px;
}
.scroll::-webkit-scrollbar {
    width: 6px;
    background: #F4F4F4;
    border-radius: 10px;
}
.scroll::-webkit-scrollbar-thumb {
    background: #dad7d7;
    border-radius: 10px;
}
.pdf-overview{
    height: 657px;
    width: 100%;
}

.img-flex {
  display:flex;
  width: 250px;
  height: 250px;
  justify-content: center;
}

.inputHidden {
  visibility: hidden;
}

#body-teste{
    width: 250px;
    border: 1px solid black;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 50px;
    border-radius: 10px;
}
.addinput{
  height: 100%;
  width: 100%;
  position: absolute;
  visibility: hidden;
}
.check-title{
  height: 20px;
  width: 20px;
  position: absolute;
  top: 8px;
  left: 5px;
  padding-left: 20px;
}
.img-body-info{
  width: 100%;
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.Icon {
  align-items: center;
  display: flex;
  width: 170px;
  height: 150px;
  color: rgb(147, 137, 139);
  background-color:#dedede;
  font-size: 50px;
  justify-content: center;
  border-style:dotted;
  cursor: pointer;
  border-radius: 10px 10px 10px 10px;

}
.img-body-dawnload{
  margin-left: 2%;
  width: 270px;
  height: 185px;
  font-size: 50px;
  color: grey;
  border-radius: 10px;
  position: relative;
  flex-direction: column;
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: 1px dotted grey;
}
.centralizatexto {
  text-align: center;
  align-items: center;
}

.import-file{
    display: flex;
    font-size: 50px;
    justify-content: center;
    align-items: center;
}

#add-new-user{
    font-size: 28px;
    background-color: #008144;
    outline: transparent;
    color:white;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    border:transparent
}

.container-modal{
  position: fixed;
  bottom: calc(50px - 1vh);
  right: 10px;
}

.container-user-form{
    display: grid;
    column-gap: 10px;
    row-gap: 10px;
    justify-content: center;
    grid-template-rows: 10% 1fr 1fr 10% 1fr 1fr;
    grid-template-columns: repeat(10,1fr);
}

#input-group-name{
    grid-row: 2;
    grid-column: 1/5;
}

#input-group-email{
    grid-row: 2;
    grid-column: 5/8;
}

#input-group-dateBirth{
    grid-row: 2;
    grid-column:  8/11;
}

#input-group-creci{
    grid-row: 3;
    grid-column: 1;
}
#input-group-uf-creci{
    grid-row: 3;
    grid-column: 2;
}
#input-group-rg{
    grid-row: 3;
    grid-column: 3/5;
}
#input-group-cpf{
    grid-row: 3;
    grid-column: 5/7;
}
#input-group-cellphone{
    grid-row: 3;
    grid-column: 7/9;
}
#input-group-comercial-phone{
    grid-row: 3;
    grid-column: 9/11;
}
#input-group-cep{
    grid-row: 5;
    grid-column: 1;
}
#input-group-city{
    grid-row: 5;
    grid-column: 2/4;
}
#input-group-address{
    grid-row: 5;
    grid-column: 4/8;
}
#input-group-district{
    grid-row: 5;
    grid-column: 8/10;
}

#input-group-number{
    grid-row: 5;
    grid-column: 10;
}

#input-group-type{
  margin-left: 20%;
  grid-row: 7;
  grid-column: 1;
}

#input-group-type2{
  grid-row: 7;
  grid-column: 2;
}

.container-buttons-form{
    grid-row: 8;
    grid-column: 1/11;
}

.title-1,
.title-2{
    /* color: #008148; */
}

.title-3{
    /* color: #008148; */
    font-weight: 800;
}

.title-1{
  grid-row: 1;
}

.title-2{
  grid-row: 4;
}
.title-3{
  grid-row: 6;
}

.container-buttons-form{
    display: flex;
    justify-content: center;
    align-items: center;
    gap:15px;
}

.button-cancel,
.button-delete,
.button-save{
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 190px;
  height: 40px;
}
.button-cancel{
  background-color: red;
  color: white;
}
.button-cancel:hover{
  background-color: #be2b2b;
  color: #dedede;
  border: #be2b2b solid 1px;
}
.button-save{
  background-color: #008148;
  color: white;
}

.button-save:hover{
  background-color: #008147d7;
  color: white;
}
.button-delete{
  background-color: #be2b2b;
  color: white;
}

/* estilização do cabeçalho do popup */

.container-hearder{
  background-color: #008144;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  align-items: center;
  padding: 25px 0;
}

.title-hearder{
  color: white;
  grid-column: 1;
  grid-row: 1;
  text-transform: uppercase;
  justify-self: center;
}

.container-close-button{
  grid-column: 1;
  grid-row: 1;
  justify-self: end;
  align-self: center;
}

.container-close-button img{
  width: 32px;
}

.img-modal-details{
  height: 400px;
  object-fit: cover;
  width: 100%;
}
/* Style the Image Used to Trigger the Modal */
#myImg {
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;
}

#myImg:hover {opacity: 0.7;}

/* The Modal (background) */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 100000; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
}

/* Modal Content (Image) */
.modal-content {
  margin: auto;
  margin-top: 1%;
  display: block;
  width: 80%;
  max-width: 700px;
}
.buttonImage[data-v-3164f3a8] {
    position: absolute;
    color: black;
    border: none;
    width: 15px;
    font-weight: bold;
    z-index: -1;
    right: 7%;
    top: 15px;
    height: 15px;
    font-size: 17px;
    border-radius: 6px;
}

.breadcrumb[data-v-5806b3d1] {
    position: fixed;
    width: 100%;
    z-index: -1;
}

/* Caption of Modal Image (Image Text) - Same Width as the Image */
#caption {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
  text-align: center;
  color: #ccc;
  padding: 10px 0;
  height: 150px;
}

/* Add Animation - Zoom in the Modal */
.modal-content, #caption {
  animation-name: zoom;
  animation-duration: 0.6s;
}

.header-title{
  color: white;
  font-weight: bold;
  font-size: 16px;
  font-family: 'Segoe UI';
}

@keyframes zoom {
  from {transform:scale(0)}
  to {transform:scale(1)}
}

/* The Close Button */
.close {
  position: absolute;
  top: 12px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px){
  .modal-content {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/enterprise/components/imageselector/imageselector.vue